import {get, post, WS_URL, BASEURL } from './https.js';

export default {
    // 获取服务器IP、ws服务IP
    getServerIP() { return get(BASEURL + 'com/ip/port/all'); },

    // 开始上课
    startLesson(param) { return post(WS_URL + 'start/lesson', param); },

    // (开始或停止)自动签到
    autoAttend(param) { return post(WS_URL + 'autoAttend', param); },

    //（准备或开始）抢答
    rushAnswer(param) { return post(WS_URL + 'rushAnswer', param); },

    //允许讨论
    startDiscuss(param) { return post(WS_URL + 'discuss', param); },

    //禁止讨论
    stopDiscuss(param) { return post(WS_URL + 'discuss', param); },

    // 开始抢答
    startResponder(param) { return post(WS_URL + 'start/responder', param); },

    // 暂停授课
    stopLesson(param) { return post(WS_URL + 'stop/lesson', param); },

    // 结束授课
    endLesson(param) {
        return get(WS_URL + 'endLesson',param);
    },

    // 分组任务——设置小组是否允许查看答案
    setTaskViewAnswer(param){ return post(WS_URL + 'task/view/answer', param); },

    // 分组任务——暂停恢复任务
    setTaskStopFlag(param){ return post(WS_URL + 'task/stop', param); },

}



// WEBPACK FOOTER //
// ./src/components/tools/request/https-ws.js